import { Component, OnInit, inject } from "@angular/core";
import { NgOptimizedImage } from "@angular/common";
import { MsalService, MsalBroadcastService } from "@azure/msal-angular";
import { Router } from "@angular/router";
import { LogoutService } from '@app/core/auth/logout.service';
import { GetUseritselfService } from "../../data/user/get-useritself.service";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { apiConfig } from "../../../environments/b2c-config";
import { getRedirectUri } from "../../utils";

@Component({
  selector: "app-join-section-confirmed",
  templateUrl: "./join-section-confirmed.component.html",
  styleUrls: ["./join-section-confirmed.component.css"],
  imports: [...SHARED_IMPORTS, NgOptimizedImage],
})
export class JoinSectionConfirmedComponent implements OnInit {
  private isLogging = false;
  private readonly logoutService = inject(LogoutService);

  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router,
    private getUseritselfService: GetUseritselfService,
  ) {}

  ngOnInit() {
    // this.subscription = this.msalBroadcastService.subscribe('msal:loginSuccess',
    //   (payload) => {
    //     this.spinner.show();
    //     this.storeAuth.setIsLoggedIn(true);
    //     this.isLoggedIn = true;
    //     //this.user = this.msalService.getUser();
    //     this.user = this.msalService.getAccount();
    //     this.getUseritself();
    //     // this.router.navigate(['/channels', 'general']);
    //   });
    // this.msalBroadcastService.subscribe('msal:loginFailure', (payload) => {
    //   this.isLoggedIn = false;
    // });
  }

  login() {
    this.isLogging = true;

    this.msalService.loginRedirect({
      scopes: [...apiConfig.scopes],
      redirectUri: getRedirectUri(),
    });
  }

  logout() {
    this.logoutService.logout();
  }
}
